module.exports = __webpack_public_path__ + "static/media/bg-hero-section-2.977a64cb.svg";